import { render, staticRenderFns } from "./NsFooter.vue?vue&type=template&id=2b6f6cf1&scoped=true"
import script from "./NsFooter.vue?vue&type=script&lang=js"
export * from "./NsFooter.vue?vue&type=script&lang=js"
import style0 from "./NsFooter.vue?vue&type=style&index=0&id=2b6f6cf1&prod&scoped=true&lang=scss"
import style1 from "./NsFooter.vue?vue&type=style&index=1&id=2b6f6cf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f6cf1",
  null
  
)

export default component.exports